import React from "react";
import abc from "../images/abc.png";
import dressify from "../images/dressify.png";
import oddgras from "../images/greenscapes.png";
import brightSight from "../images/brightSight.png";

import { SiTypescript, SiTwilio, SiOpenai, SiSupabase, SiTailwindcss, SiPuppeteer, SiRedux } from "react-icons/si";
import { FaCss3Alt, FaJsSquare, FaHtml5, FaNodeJs, FaReact } from "react-icons/fa";
// https://react-icons.github.io/react-icons/icons?name=fa

let projects = [
  {
    title: "WorkFlow",
    img1: abc,
    description:
      "A WhatsApp-first workforce management platform that enables businesses to manage attendance, communication, and operations without a separate app. Built with Node.js, Express, Twilio, and Supabase, it features automated attendance tracking and a RAG-powered AI assistant for conversational workforce data queries.",
    skills: [
      {
        name: "REACT",
        icon: <FaReact />,
      },
      {
        name: "NODEJS",
        icon: <FaNodeJs />,
      },
      {
        name: "TWILIO",
        icon: <SiTwilio />,
      }
    ],
    git: "https://github.com/astik0398/whatsapp-work-hub",
    preview: "https://whatsapp-work-hub.vercel.app",
  },
  {
    title: "MediBachat",
    img1: dressify,
    description:
      "A medicine price comparison platform that helps users find affordable medicines across multiple online pharmacies. Built with Node.js and Puppeteer, it aggregates real-time pricing data, is SEO-optimized, and helps users save money on essential medications.",
    skills: [
      {
        name: "REACT",
        icon: <FaReact />,
      },
      {
        name: "TAILWIND",
        icon: <SiTailwindcss />,
      },
      {
        name: "PUPPETEER",
        icon: <SiPuppeteer />,
      },
    ],
    git: "https://github.com/astik0398/medsave-india",
    preview: "https://medibachat.in",
  },
  {
    title: "Green Escapes",
    img1: oddgras,
    description:
      "If you are into exploring natures then our website Green Escapes is for you. This website mainly targets the people who love adventures and travelling the world. It provides facilities to book your destination, Hotels and Activities in just one click. It has simple and user Friendly UI/UX.",

    skills: [
      {
        name: "HTML",
        icon: <FaHtml5 />,
      },
      {
        name: "CSS",
        icon: <FaCss3Alt />,
      },
      {
        name: "JS",
        icon: <FaJsSquare />,
      },
    ],
    git: "https://github.com/harsh7739/odd-grass-4307",
    preview: "https://resonant-meringue-f6cdea.netlify.app/index.html",
  },
  {
    title: "Bright Sight",
    img1: brightSight,
    description:
      "This website is dedicated to providing top-notch ophthalmological services with ease and convenience. Whether you're looking to book an appointment with a specialist or simply seeking information about our experienced doctors, you've come to the right place.",

    skills: [
      {
        name: "REACT",
        icon: <FaReact />,
      },
      {
        name: "REDUX",
        icon: <SiRedux />,
      },
      {
        name: "CHAKRA",
        icon: <FaCss3Alt />,
      },
    ],
    git: "https://github.com/astik0398/precious-plate-5541",
    preview: "https://bright-sight.netlify.app/",
  },
  // {
  //   title: "project-1",
  //   img1: abc,
  //   img2: abc2,
  //   description: "Dressify is one-stop destination for fashionable clothing and accessories for men, women and children. Anyone can go through the wide range of products that are available on our website and order the desired one",

  //   skills: [
  //     {
  //       name: "HTML",
  //       icon: <FaHtml5 />,
  //     },
  //     {
  //       name: "CSS",
  //       icon: <FaCss3Alt />,
  //     },
  //     {
  //       name: "JS",
  //       icon: <FaJsSquare />,
  //     },
  //   ],
  //   git: "https://github.com/astik0398/ambiguous-oven-8467",
  //   preview: "https://dressify-shopping.netlify.app/",
  // },
  // {
  //   title: "project-2",
  //   img1: abc,
  //   img2: abc2,
  //   description: "Dressify is one-stop destination for fashionable clothing and accessories for men, women and children. Anyone can go through the wide range of products that are available on our website and order the desired one",

  //   skills: [
  //     {
  //       name: "HTML",
  //       icon: <FaHtml5 />,
  //     },
  //     {
  //       name: "CSS",
  //       icon: <FaCss3Alt />,
  //     },
  //     {
  //       name: "JS",
  //       icon: <FaJsSquare />,
  //     },
  //   ],
  //   git: "https://github.com/astik0398/ambiguous-oven-8467",
  //   preview: "https://dressify-shopping.netlify.app/",
  // },
];

function Projects() {
  return (
    <div id="projects">
      <h1
        style={{
          backgroundColor: "#200589",
          width: "220px",
          margin: "auto",
          padding: "5px",
          borderRadius: "15px",
          color: "white",
        }}
      >
        My Projects{" "}
      </h1>
      <div className="all_projects">
        {projects.map((el) => (
          <div className="project-card">
            <div
              style={{ display: "flex", alignItems: "center" }}
              className="pro-img"
            >
              <img src={el.img1} alt="" />
            </div>

            <div className="pro-Info">
              <h2 className="project-title">{el.title}</h2>
              <p className="project-description">{el.description}</p>
              <h2>Tech Stack</h2>
              <div className="project-tech-stack">
                {el.skills.map((skill) => (
                  <div className="skills-card">
                    {skill.icon}
                    <p style={{ fontSize: "20px" }}>{skill.name}</p>
                  </div>
                ))}
              </div>
              <div
                className="pro-anchortag"
                style={{ display: "flex", margin: "auto", gap: "0px"}}
              >
                <a
                  className="project-github-link"
                  href={el.git}
                  target="_blank"
                >
                  <button id="gt_btn">View on Github</button>
                </a>
                <a
                  className="project-deployed-link"
                  target="_blank"
                  href={el.preview}
                >
                  <button id="dep_btn">Visit Website</button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;

// Each project card in the Projects section should have class="project-card" and the following:
// Image of the project
// Title : class="project-title"
// Description : class="project-description"
// Tech stack used : class="project-tech-stack"
// Link to GitHub repository : class="project-github-link"
// Deployed link or video link : class="project-deployed-link"
